export default __webpack_public_path__ + "static/media/done-like.38553776.svg";